export class Itemtype {
    public displayName?: string;
    public description: string;
    public createdDate: string;
  }
  